import { useEffect } from "react";

/**
 * Set the document title and meta description for the current route.
 *
 * This is a deliberately small stand-in for react-helmet: the site has three
 * page types, so a dependency is not warranted. Note that because this runs in
 * the browser it improves sharing and tab legibility, but crawlers that do not
 * execute JavaScript will only see the defaults in `public/index.html` — the
 * static fallbacks there are written to be accurate on their own.
 *
 * @param {Object} props
 * @param {string} props.title        Full document title.
 * @param {string} [props.description] Meta description, ~155 characters.
 * @returns {null}
 */
function DocumentHead({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (!description) return;

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement("meta");
      descriptionTag.setAttribute("name", "description");
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.setAttribute("content", description);
  }, [title, description]);

  return null;
}

export default DocumentHead;
